import React, { useState, useEffect } from 'react';
import { ApplicationInterface } from "../interfaces";
import CustomButton from "../../../components/CustomButton";
import iconAlert from "url:shared-assets/icons/red/alert.svg"
import {scrollTop} from "../../../helpers/scrolling";

interface Props {
    application: ApplicationInterface;
    save: Function
}


const StepOne: React.FC<Props> = (props: Props) => {
    const [firstName, setFirstName] = useState<string>(props.application.firstName);
    const [lastName, setLastName] = useState<string>(props.application.lastName);
    const [phone, setPhone] = useState<string>(props.application.phone);
    const [company, setCompany] = useState<string>(props.application.company);
    const [organisationNumber, setOrganisationNumber] = useState<string>(props.application.organisationNumber);
    const [companyAddress, setCompanyAddress] = useState<string>(props.application.companyAddress);
    const [errors, setErrors] = useState<number>(0)
    const [errorFields, setErrorFields] = useState<Array<string>>(["", "", "", "", "", ""])
    const [triedSave, setTriedSave] = useState<boolean>(false)

    useEffect(() => {
        scrollTop()
    }, [])

    useEffect(() => {
        if (triedSave) {
            checkInput()
        }
    }, [firstName, lastName, phone, company, organisationNumber, companyAddress])

    const checkInput = () => {
        let _errors = 0
        const _errorFields = ["", "", "", "", "", ""]
        if (firstName.length < 1) {
            _errors++
            _errorFields[0] = "Too short"
        }
        if (lastName.length < 1) {
            _errors++
            _errorFields[1] = "Too short"
        }
        if (phone.length < 1) {
            _errors++
            _errorFields[2] = "Too short"
        }
        if (company.length < 1) {
            _errors++
            _errorFields[3] = "Too short"
        }
        if (organisationNumber.length < 1) {
            _errors++
            _errorFields[4] = "Too short"
        }
        if (companyAddress.length < 1) {
            _errors++
            _errorFields[5] = "Too short"
        }
        setErrors(_errors)
        setErrorFields(_errorFields)
        return _errors
    }

    const save = () => {
        setTriedSave(true)
        if (checkInput() > 0) {
            console.log('There are errors')
            return
        }

        const _application: ApplicationInterface = props.application
        _application.firstName = firstName
        _application.lastName = lastName
        _application.phone = phone
        _application.company = company
        _application.organisationNumber = organisationNumber
        _application.companyAddress = companyAddress
        props.save(_application)
    }
    return (
        <>
            <div className="mt-6 text-xl font-medium">Personal and company details</div>

            <div className="mt-6 ring-primary-500">First name</div>
            <input value={firstName}
                   className={"z-input mt-2" + (triedSave && errorFields[0] ? " error" : "")}
                   onChange={(e) => setFirstName(e.target.value)}/>

            <div className="mt-6">Last name</div>
            <input value={lastName}
                   className={"z-input mt-2" + (triedSave && errorFields[1] ? " error" : "")}
                   onChange={(e) => setLastName(e.target.value)}/>

            <div className="mt-6">Phone number</div>
            <input value={phone} placeholder="+46701234567"
                   className={"z-input mt-2" + (triedSave && errorFields[2] ? " error" : "")}
                   onChange={(e) => setPhone(e.target.value)}/>

            <div className="mt-6">Company name</div>
            <input value={company}
                   className={"z-input mt-2" + (triedSave && errorFields[3] ? " error" : "")}
                   onChange={(e) => setCompany(e.target.value)}/>

            <div className="mt-6">Organisation number</div>
            <input value={organisationNumber}
                   className={"z-input mt-2" + (triedSave && errorFields[4] ? " error" : "")}
                   onChange={(e) => setOrganisationNumber(e.target.value)}/>

            <div className="mt-6">Company address</div>
            <input value={companyAddress}
                   className={"z-input mt-2" + (triedSave && errorFields[5] ? " error" : "")}
                   onChange={(e) => setCompanyAddress(e.target.value)}/>

            {
                (triedSave && errors > 0) &&
                <div className="mt-6 p-4 bg-neutral-700 border rounded-md border-cherry-500 flex items-center">
                    <img src={iconAlert} alt="error"/>
                    <div className="ml-2 font-medium">Please make sure all fields are filled out correctly</div>
                </div>
            }

            <CustomButton className="mt-6" onClick={() => save()}>
                Next
            </CustomButton>
        </>
    )
}

export default StepOne